<mat-toolbar class="action-toolbar cf-flex-1 cf-flex-row cf-justify-content-start cf-align-items-center">
  @if (!hideButtons) {
    <app-delete-button [isLoading]="isLoading" (delete)="onDelete()"></app-delete-button>
  }
  <div class="cf-flex-auto"></div>
  <div class="cf-flex-row cf-justify-content-start cf-align-items-center cf-gap-16">
    <ng-content></ng-content>
    @if (!hideButtons) {
      <button mat-button (click)="onDiscard()" [disabled]="!canDiscard">
        {{ 'UI.Discard' | translate | uppercase }}
      </button>
      <button mat-button class="primary-button" [disabled]="!canSave" (click)="onSave()">
        {{ 'UI.Save' | translate | uppercase }}
      </button>
    }
  </div>
</mat-toolbar>
